import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_APPLICANTS: string = typeCreatorV2(
  'ApplicantsReducer',
  'SetApplicants'
);

export const RESEND_VERIFICATION_LINK: string = typeCreatorV2(
  'ApplicantsReducer',
  'ResendVerificationLink'
);
